import img1 from "../images/vitiligo5.jpg";
import img3 from "../images/vitiligo4.jpg";
import img6 from "../images/Psoriasis.jpg";
import img7 from "../images/psoriasis 1.jpg";
import img8 from "../images/acne.jpg";
import img9 from "../images/Main frame.jpg";
import img10 from "../images/leucoderma.jpg";
import img11 from "../images/Nature.png";
import img13 from "../images/homeimage.png";
import img14 from "../images/Acn3.jpg";
import img15 from "../images/Acn4.jpg";
import img16 from "../images/Psoriasis-2.jpg";
export const main = [img9, img13, img11];

export const DiseaseList = [
  {
    name: "Leucoderma/Vitiligo",
    image: [img1, img3, img10],
    introduction:
      "In Ayurveda, Leucoderma, also known as Vitiligo, is referred to as Safed Roga or Switra. It is a chronic skin condition characterized by white patches on the skin due to the loss of melanin pigment. Ayurveda attributes Leucoderma to an imbalance in the three doshas – Vata, Pitta, and Kapha – along with the accumulation of toxins (ama) in the body. The vitiation of Vata dosha is primarily responsible for affecting the melanocytes and causing depigmentation. Ayurvedic treatment for Leucoderma aims to balance the doshas, eliminate toxins, and promote re-pigmentation of affected areas. Panchakarma detoxification therapies are used to cleanse the body, and herbal medications with immunomodulatory properties, such as Psoralea corylifolia (Bakuchi) and Tinospora cordifolia (Guduchi), are often prescribed to stimulate melanin production. Ayurveda considers Leucoderma not only as a skin disorder but also as an indication of internal disharmony, addressing both physical and emotional aspects during treatment.",
    cause:
      "In Ayurveda, Leucoderma (Vitiligo) is caused by an imbalance in the three doshas (Vata, Pitta, and Kapha) and the accumulation of toxins (ama) in the body. Aggravated Pitta dosha leads to the destruction of melanocytes, resulting in depigmentation. The presence of toxins disrupts nutrient flow to the skin, contributing to skin disorders. Emotional factors like stress and poor diet/lifestyle choices also play a role. Genetic predisposition may also be a contributing factor. Ayurvedic treatment focuses on restoring dosha balance, eliminating toxins, and promoting skin health through herbal medicines, Panchakarma detoxification, and stress management techniques.",
    treatment: [
      "Panchakarma Therapy: Panchakarma is a set of five detoxification procedures that help eliminate toxins (ama) from the body. These procedures include Vamana (emesis), Virechana (purgation), Basti (enema), Nasya (nasal administration), and Raktamokshana (bloodletting). Panchakarma helps to purify the blood and tissues, promoting overall health.",
      "Herbal Medications : Ayurvedic practitioners use a combination of herbs with potent properties to stimulate melanin production and aid in repigmentation. Herbs like Psoralea corylifolia (Bakuchi), Tinospora cordifolia (Guduchi), and Rubia cordifolia (Manjistha) are commonly used to treat Leucoderma.",
      "Dietary Modifications: Ayurveda emphasizes the importance of a balanced and nutritious diet to support the body's healing process. Foods that aggravate Pitta dosha, like sour, spicy, and oily foods, may be avoided, while fresh fruits, vegetables, and herbal teas are encouraged.",
      "Lifestyle Changes: Stress and anxiety can worsen Leucoderma, so stress-reduction techniques like yoga, meditation, and pranayama (breathing exercises) are recommended.",
      "External Therapies: Ayurvedic external therapies like Abhyanga (massage with medicated oils) and Lepa (applying herbal pastes) may be used to nourish the skin and promote repigmentation.",
    ],
    brief:
      " At Sudama Ayurveda, we take pride in our 25+ years of experience in providing effective and holistic treatment for Leucoderma. Our experienced Ayurvedic practitioners tailor the treatment approach to suit each patient's specific needs, ensuring the best possible outcomes in managing this challenging skin condition.",
  },

  {
    name: "Psoriasis",
    image: [img6, img7, img16],
    introduction: `In Ayurveda, Psoriasis is known as 'Ekakushta,' which translates to 'one that affects the skin.' It is considered a chronic skin disorder caused by an imbalance in the body's doshas – Vata, Pitta, and Kapha – along with the accumulation of toxins (ama) in the body. Ayurveda views Psoriasis as a manifestation of internal disharmony that affects the skin.According to Ayurvedic principles, Psoriasis is primarily associated with an aggravated Vata dosha and impaired blood and liver functions. The accumulation of ama (toxins) in the body, due to improper digestion and metabolism, further exacerbates the condition. These imbalances lead to the inflammation of skin tissues and the formation of characteristic silvery-white scales and red patches on the skin's surface. Ayurvedic treatment for Psoriasis aims to correct the underlying imbalances in the body and eliminate accumulated toxins. It follows a holistic approach that includes dietary modifications, lifestyle changes, herbal remedies, Panchakarma therapies, and stress management techniques.`,
    cause:
      "Psoriasis in Ayurveda is primarily caused by an imbalance in the body's doshas – Vata, Pitta, and Kapha – along with the accumulation of toxins (ama). The vitiation of Vata dosha is considered the main contributor to the development of Psoriasis. This doshic imbalance leads to inflammation and disruption of the skin's natural functions, resulting in the characteristic red, raised, and scaled patches. Ayurvedic treatment aims to correct these imbalances, eliminate toxins, and promote overall skin health through dietary adjustments, lifestyle changes, herbal remedies, and detoxification therapies.",
    treatment: [
      "Panchakarma Therapy: Panchakarma is a set of detoxification procedures that help eliminate toxins (ama) from the body. These procedures include Vamana (emesis), Virechana (purgation), Basti (enema), Nasya (nasal administration), and Raktamokshana (bloodletting). Panchakarma helps to purify the blood and tissues, promoting overall health and aiding in the management of Psoriasis.",
      "Herbal Medications: Ayurvedic practitioners use a combination of herbs with potent properties to reduce inflammation, soothe the skin, and promote healing. Medicinal herbs like Neem (Azadirachta indica), Aloe vera, and Turmeric (Curcuma longa) are commonly used for their anti-inflammatory and antimicrobial effects.",
      "Dietary Modifications: Ayurveda emphasizes the importance of a balanced and wholesome diet to support the body's healing process. Foods that aggravate Pitta dosha, such as spicy, fried, and processed foods, are usually avoided, while fresh fruits, vegetables, and herbal teas are encouraged.",
      "Lifestyle Changes: Stress is considered a trigger for Psoriasis, so stress-reduction techniques like yoga, meditation, and pranayama (breathing exercises) are recommended to manage the condition effectively.",
      "External Therapies: Ayurvedic external therapies like Abhyanga (massage with medicated oils) and Takradhara (pouring medicated buttermilk over the affected area) may be used to nourish the skin and promote healing.",
      "A balanced approach to holistic health: Ayurveda recognizes the interconnectedness of body, mind, and spirit. Therefore, addressing emotional well-being and adopting a positive outlook are also essential aspects of the treatment.",
    ],
    brief:
      "At Sudama Ayurveda, we take pride in our 25+ years of experience in providing effective and holistic treatment for Psoriasis. Our experienced Ayurvedic practitioners tailor the treatment approach to suit each patient's specific needs, ensuring the best possible outcomes in managing this challenging skin condition.",
  },

  {
    name: "Acne",
    image: [img8, img14, img15],
    introduction:
      "In Ayurveda, Acne is known as 'Yauvan Pidika' or 'Mukha Dushika,' which translates to 'adolescent eruptions' or 'pimples on the face.' Acne is a common skin condition that affects the face, chest, and back. According to Ayurvedic principles, acne is primarily caused by an imbalance in the body's doshas, especially Pitta and Kapha.",
    cause:
      "Acne in Ayurveda is primarily caused by an imbalance in the body's doshas, especially Pitta and Kapha. Excessive Pitta leads to inflammation and heat accumulation, while imbalanced Kapha can result in excess oil production and clogged pores. Other contributing factors include impaired digestion, hormonal imbalances, poor lifestyle choices, and external factors. Ayurvedic treatment for acne focuses on restoring dosha balance, detoxification, dietary modifications, herbal remedies, stress management, and proper skincare to address the root causes and promote clear and healthy skin.",
    treatment: [
      "Dietary Modifications: Emphasizing a Pitta-pacifying diet that includes cooling and soothing foods can help reduce heat and inflammation. Avoiding spicy, oily, and fried foods, as well as excessive consumption of caffeine and alcohol, is recommended.",
      "Herbal Remedies: Ayurvedic practitioners use herbs with anti-inflammatory and detoxifying properties to address acne. Neem (Azadirachta indica), Manjistha (Rubia cordifolia), Turmeric (Curcuma longa), and Guduchi (Tinospora cordifolia) are commonly used for their skin-healing properties.",
      "Detoxification (Panchakarma): Panchakarma therapies, such as Virechana (purgation) and Vamana (emesis), help eliminate toxins from the body, promoting overall skin health.",
      "Stress Management: Stress can worsen acne, so practicing relaxation techniques like yoga, meditation, and deep breathing can be beneficial.",
      "Skincare: Ayurvedic skincare involves using natural ingredients like rose water, sandalwood, and aloe vera to cleanse and nourish the skin without causing irritation.",
      "Lifestyle Recommendations: Maintaining a regular sleep schedule, staying hydrated, and adopting a healthy lifestyle are crucial for managing acne.",
    ],
    brief:
      "At Sudama Ayushdhalya, we take pride in our 25+ years of expertise in the treatment of various skin conditions, including Acne, Psoriasis, Leucoderma (Vitiligo), and more. Our experienced Ayurvedic practitioners are dedicated to providing effective and holistic solutions for skin-related issues.",
  },
];

export let testimonials = [
  {
    name: "Shashank",
    testament: "Sudama Aushdhalya ne humari bahot madad ki. Bahut shukriya!",
    location: "Mumbai, Maharashtra",
  },
  {
    name: "Rajesh",
    testament:
      "Sudama Aushdhalya ne mere liye ek chamatkari ilaj kiya! Bahut dhanyavaad!",
    location: "Jaipur, Rajasthan",
  },
  {
    name: "Ritu",
    testament:
      "Unki ayurvedic dawaiyon ne meri skin ki samasya ko jad se khatam kar diya. Bilkul shandar!",
    location: "Lucknow, Uttar Pradesh",
  },
  {
    name: "Sameer",
    testament:
      "Mujhe acne ki problem thi, lekin Sudama Aushdhalya ki treatment ne use thik kar diya. Bahut khush hu!",
    location: "Bengaluru, Karnataka",
  },
  {
    name: "Ananya",
    testament:
      "Inke experience aur knowledge se mujhe psoriasis ka treatment mila, ab meri skin bilkul saaf hai!",
    location: "Chennai, Tamil Nadu",
  },
  {
    name: "Priya",
    testament:
      "Sudama Aushdhalya ke ayurvedic nuskhe se mere chehre ke daag-dhabbe gayab ho gaye. Mai unka dhanyavaad karti hu!",
    location: "Delhi",
  },
  {
    name: "Alok",
    testament:
      "Inki skin care tips ko follow karne se mere baal ghane aur chamakdar ho gaye hai. Unka bahut bahut shukriya!",
    location: "Kolkata, West Bengal",
  },
  {
    name: "Sneha",
    testament:
      "Sudama Aushdhalya mein unke sujhaav par jakar mere skin problems ka ilaj hua. Ab meri skin bahut acchi hai!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Akash",
    testament:
      "Mere dark circles ki samasya ko solve karne ke liye Sudama Aushdhalya ne mujhe ek acha solution diya. Ab meri aankhen khubsurat dikhti hai!",
    location: "Hyderabad, Telangana",
  },
  {
    name: "Pooja",
    testament:
      "Unki ayurvedic dawaiyon se mere pimples aur acne ki samasya kafi had tak thik ho gayi hai. Unka bahut bahut shukriya!",
    location: "Pune, Maharashtra",
  },
  {
    name: "Amit",
    testament:
      "Sudama Aushdhalya ki vajah se meri skin ki jalan aur khujli gayab ho gayi hai. Bahut accha result mila hai!",
    location: "Surat, Gujarat",
  },
  {
    name: "Kavita",
    testament:
      "Mere chehre par jo muhase the, unka koi asar nahi dikhta tha. Lekin unki dawaiyon se ab meri skin chamak rahi hai!",
    location: "Jaipur, Rajasthan",
  },
  {
    name: "Juhi",
    testament:
      "Unki skin care tips se mere baalon ki samasya door ho gayi hai. Bahut hi achhi service hai!",
    location: "Chandigarh",
  },
  {
    name: "Nikhil",
    testament:
      "Sudama Aushdhalya ke prakritik dawaiyon se mere skin ki allergy theek ho gayi hai. Mai unko recommend karunga!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Aarti",
    testament:
      "Mere skin par hone wale rashes ko Sudama Aushdhalya ke upchar ne thik kar diya. Unka bahut abhari hu!",
    location: "Gurugram, Haryana",
  },
  {
    name: "Rahul",
    testament:
      "Unki ayurvedic nuskho se mere skin ke problems ko hamesha ke liye dur kar diya. Bahut sahi tareeka hai unka!",
    location: "Indore, Madhya Pradesh",
  },
  {
    name: "Kiran",
    testament:
      "Sudama Aushdhalya ki dawaiyon se mere face ke pimples gayab ho gaye. Unka treatment bahut effective hai!",
    location: "Thane, Maharashtra",
  },
  {
    name: "Rohit",
    testament:
      "Unke herbal upchar se mere skin ke daag-dhabbe gayab ho gaye. Mai unka shukriya ada karta hu!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Neha",
    testament:
      "Sudama Aushdhalya ki ayurvedic dawaiyon se mere hair fall ki problem dur ho gayi hai. Bahut accha hai unka treatment!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Vishal",
    testament:
      "Mere skin ke rashes ko thik karne ke liye Sudama Aushdhalya ne mujhe ek acha solution diya. Mai unko recommend karunga!",
    location: "Lucknow, Uttar Pradesh",
  },
  {
    name: "Arti",
    testament:
      "Unki ayurvedic dawaiyon se mere face ke acne kafi had tak thik ho gaye hai. Unka bahut bahut shukriya!",
    location: "Chennai, Tamil Nadu",
  },
  {
    name: "Aakash",
    testament:
      "Sudama Aushdhalya ne mere skin ki problem ko jaldi se thik kar diya. Unke treatment se mujhe bahut fayda hua hai!",
    location: "Bengaluru, Karnataka",
  },
  {
    name: "Mansi",
    testament:
      "Mujhe psoriasis ki problem thi, lekin Sudama Aushdhalya ke treatment ne use thik kar diya. Mai unka abhari hu!",
    location: "Delhi",
  },
  {
    name: "Vivek",
    testament:
      "Unki ayurvedic nuskhe se mere baal ghane ho gaye hai. Mai unko dhanyavaad karta hu!",
    location: "Kolkata, West Bengal",
  },
  {
    name: "Naina",
    testament:
      "Sudama Aushdhalya ki skin care tips ko follow karne se meri skin bilkul saaf aur chamakdar ho gayi hai. Bahut accha hai unka treatment!",
    location: "Hyderabad, Telangana",
  },
  {
    name: "Aryan",
    testament:
      "Mere dark circles ko door karne ke liye Sudama Aushdhalya ke upay kaam aaye. Mai unko recommend karunga!",
    location: "Mumbai, Maharashtra",
  },
  {
    name: "Meera",
    testament:
      "Unki ayurvedic dawaiyon se mere skin ke daag-dhabbe dur ho gaye hai. Unka treatment bahut effective hai!",
    location: "Pune, Maharashtra",
  },
  {
    name: "Rohini",
    testament:
      "Sudama Aushdhalya ke prakritik upchar se mere face ke pimples thik ho gaye hai. Unka treatment bahut achha hai!",
    location: "Bengaluru, Karnataka",
  },
  {
    name: "Surya",
    testament:
      "Mere hair fall ki samasya ke liye Sudama Aushdhalya ke herbal dawaiyon ne kaam kiya. Ab mere baal majboot hai!",
    location: "Jaipur, Rajasthan",
  },
  {
    name: "Khushi",
    testament:
      "Unki ayurvedic dawaiyon se mere skin ki khujli aur sujan thik ho gayi hai. Mai unka dhanyavaad karti hu!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Rahul",
    testament:
      "Sudama Aushdhalya ke sujhav se meri skin ki problem dur ho gayi hai. Unka treatment bahut asardar hai!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Anjali",
    testament:
      "Mujhe psoriasis ki problem thi, lekin Sudama Aushdhalya ke upchar se ab meri skin normal hai. Unka bahut bahut shukriya!",
    location: "Kolkata, West Bengal",
  },
  {
    name: "Alok",
    testament:
      "Unki ayurvedic dawaiyon se mere face ke daag-dhabbe gayab ho gaye. Ab meri skin chamak rahi hai!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Tanvi",
    testament:
      "Sudama Aushdhalya ke herbal upchar se mere skin ki glow badhi hai. Unka treatment bahut accha hai!",
    location: "Chennai, Tamil Nadu",
  },
  {
    name: "Arjun",
    testament:
      "Mere hair fall ki problem ko thik karne ke liye Sudama Aushdhalya ne mujhe ek acha solution diya. Unka treatment mujhe pasand aaya!",
    location: "Mumbai, Maharashtra",
  },
  {
    name: "Kavya",
    testament:
      "Unki ayurvedic skin care tips se mere skin ki dryness aur roughness dur ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Delhi",
  },
  {
    name: "Shubham",
    testament:
      "Sudama Aushdhalya ke upchar se mere chehre ki jhuriya kam ho gayi hai. Unka treatment bahut effective hai!",
    location: "Hyderabad, Telangana",
  },
  {
    name: "Nisha",
    testament:
      "Mere dark circles ko thik karne ke liye Sudama Aushdhalya ke tips ne kaam kiya. Mai unko recommend karungi!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Ravi",
    testament:
      "Unki ayurvedic dawaiyon se mere skin ki allergy kafi had tak thik ho gayi hai. Unka bahut bahut shukriya!",
    location: "Pune, Maharashtra",
  },
  {
    name: "Aarti",
    testament:
      "Sudama Aushdhalya ki vajah se meri skin ki jalan aur khujli gayab ho gayi hai. Unka treatment bahut accha hai!",
    location: "Lucknow, Uttar Pradesh",
  },
  {
    name: "Vikas",
    testament:
      "Mere chehre par jo muhase the, unka koi asar nahi dikhta tha. Lekin Sudama Aushdhalya ke upchar se ab meri skin saaf hai!",
    location: "Chandigarh",
  },
  {
    name: "Juhi",
    testament:
      "Unki ayurvedic dawaiyon se mere baalon ki samasya dur ho gayi hai. Mai unko dhanyavaad karti hu!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Raj",
    testament:
      "Sudama Aushdhalya ke tips se mere face ke daag-dhabbe kam ho gaye. Unka treatment mujhe pasand aaya!",
    location: "Gurugram, Haryana",
  },
  {
    name: "Prachi",
    testament:
      "Unki ayurvedic nuskhe se mere skin ki problems kafi had tak thik ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Indore, Madhya Pradesh",
  },
  {
    name: "Amit",
    testament:
      "Sudama Aushdhalya ke upchar se mere face ke pimples gayab ho gaye hai. Mai unko recommend karunga!",
    location: "Thane, Maharashtra",
  },
  {
    name: "Nidhi",
    testament:
      "Unke herbal dawaiyon se mere skin ke daag-dhabbe dur ho gaye hai. Unka treatment bahut effective hai!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Rohit",
    testament:
      "Sudama Aushdhalya ki ayurvedic dawaiyon se mere hair fall ki samasya dur ho gayi hai. Bahut accha hai unka treatment!",
    location: "Jaipur, Rajasthan",
  },
  {
    name: "Kriti",
    testament:
      "Mere skin ki khujli aur sujan ko Sudama Aushdhalya ke upchar ne thik kiya. Mai unka bahut abhari hu!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Rahul",
    testament:
      "Unke sujhaav se meri skin ki problem dur ho gayi hai. Sudama Aushdhalya ka treatment bahut asardar hai!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Anjali",
    testament:
      "Mujhe psoriasis ki problem thi, lekin Sudama Aushdhalya ke upchar se ab meri skin normal hai. Unka bahut bahut shukriya!",
    location: "Kolkata, West Bengal",
  },
  {
    name: "Alok",
    testament:
      "Unki ayurvedic dawaiyon se mere face ke daag-dhabbe gayab ho gaye. Ab meri skin chamak rahi hai!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Tanvi",
    testament:
      "Sudama Aushdhalya ke herbal upchar se mere skin ki glow badhi hai. Unka treatment bahut accha hai!",
    location: "Chennai, Tamil Nadu",
  },
  {
    name: "Arjun",
    testament:
      "Mere hair fall ki problem ko thik karne ke liye Sudama Aushdhalya ne mujhe ek acha solution diya. Unka treatment mujhe pasand aaya!",
    location: "Mumbai, Maharashtra",
  },
  {
    name: "Kavya",
    testament:
      "Unki ayurvedic skin care tips se mere skin ki dryness aur roughness dur ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Delhi",
  },
  {
    name: "Shubham",
    testament:
      "Sudama Aushdhalya ke upchar se mere chehre ki jhuriya kam ho gayi hai. Unka treatment bahut effective hai!",
    location: "Hyderabad, Telangana",
  },
  {
    name: "Nisha",
    testament:
      "Mere dark circles ko thik karne ke liye Sudama Aushdhalya ke tips ne kaam kiya. Mai unko recommend karungi!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Ravi",
    testament:
      "Unki ayurvedic dawaiyon se mere skin ki allergy kafi had tak thik ho gayi hai. Unka bahut bahut shukriya!",
    location: "Pune, Maharashtra",
  },
  {
    name: "Aarti",
    testament:
      "Sudama Aushdhalya ki vajah se meri skin ki jalan aur khujli gayab ho gayi hai. Unka treatment bahut accha hai!",
    location: "Lucknow, Uttar Pradesh",
  },
  {
    name: "Vikas",
    testament:
      "Mere chehre par jo muhase the, unka koi asar nahi dikhta tha. Lekin Sudama Aushdhalya ke upchar se ab meri skin saaf hai!",
    location: "Chandigarh",
  },
  {
    name: "Juhi",
    testament:
      "Unki ayurvedic dawaiyon se mere baalon ki samasya dur ho gayi hai. Mai unko dhanyavaad karti hu!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Raj",
    testament:
      "Sudama Aushdhalya ke tips se mere face ke daag-dhabbe kam ho gaye. Unka treatment mujhe pasand aaya!",
    location: "Gurugram, Haryana",
  },
  {
    name: "Prachi",
    testament:
      "Unki ayurvedic nuskhe se mere skin ki problems kafi had tak thik ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Indore, Madhya Pradesh",
  },
  {
    name: "Amit",
    testament:
      "Sudama Aushdhalya ke upchar se mere face ke pimples gayab ho gaye hai. Mai unko recommend karunga!",
    location: "Thane, Maharashtra",
  },
  {
    name: "Nidhi",
    testament:
      "Unke herbal dawaiyon se mere skin ke daag-dhabbe dur ho gaye hai. Unka treatment bahut effective hai!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Rohit",
    testament:
      "Sudama Aushdhalya ki ayurvedic dawaiyon se mere hair fall ki samasya dur ho gayi hai. Bahut accha hai unka treatment!",
    location: "Jaipur, Rajasthan",
  },
  {
    name: "Kriti",
    testament:
      "Mere skin ki khujli aur sujan ko Sudama Aushdhalya ke upchar ne thik kiya. Mai unka bahut abhari hu!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Rahul",
    testament:
      "Unke sujhaav se meri skin ki problem dur ho gayi hai. Sudama Aushdhalya ka treatment bahut asardar hai!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Anjali",
    testament:
      "Mujhe psoriasis ki problem thi, lekin Sudama Aushdhalya ke upchar se ab meri skin normal hai. Unka bahut bahut shukriya!",
    location: "Kolkata, West Bengal",
  },
  {
    name: "Alok",
    testament:
      "Unki ayurvedic dawaiyon se mere face ke daag-dhabbe gayab ho gaye. Ab meri skin chamak rahi hai!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Tanvi",
    testament:
      "Sudama Aushdhalya ke herbal upchar se mere skin ki glow badhi hai. Unka treatment bahut accha hai!",
    location: "Chennai, Tamil Nadu",
  },
  {
    name: "Arjun",
    testament:
      "Mere hair fall ki problem ko thik karne ke liye Sudama Aushdhalya ne mujhe ek acha solution diya. Unka treatment mujhe pasand aaya!",
    location: "Mumbai, Maharashtra",
  },
  {
    name: "Kavya",
    testament:
      "Unki ayurvedic skin care tips se mere skin ki dryness aur roughness dur ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Delhi",
  },
  {
    name: "Shubham",
    testament:
      "Sudama Aushdhalya ke upchar se mere chehre ki jhuriya kam ho gayi hai. Unka treatment bahut effective hai!",
    location: "Hyderabad, Telangana",
  },
  {
    name: "Nisha",
    testament:
      "Mere dark circles ko thik karne ke liye Sudama Aushdhalya ke tips ne kaam kiya. Mai unko recommend karungi!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Ravi",
    testament:
      "Unki ayurvedic dawaiyon se mere skin ki allergy kafi had tak thik ho gayi hai. Unka bahut bahut shukriya!",
    location: "Pune, Maharashtra",
  },
  {
    name: "Aarti",
    testament:
      "Sudama Aushdhalya ki vajah se meri skin ki jalan aur khujli gayab ho gayi hai. Unka treatment bahut accha hai!",
    location: "Lucknow, Uttar Pradesh",
  },
  {
    name: "Vikas",
    testament:
      "Mere chehre par jo muhase the, unka koi asar nahi dikhta tha. Lekin Sudama Aushdhalya ke upchar se ab meri skin saaf hai!",
    location: "Chandigarh",
  },
  {
    name: "Juhi",
    testament:
      "Unki ayurvedic dawaiyon se mere baalon ki samasya dur ho gayi hai. Mai unko dhanyavaad karti hu!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Raj",
    testament:
      "Sudama Aushdhalya ke tips se mere face ke daag-dhabbe kam ho gaye. Unka treatment mujhe pasand aaya!",
    location: "Gurugram, Haryana",
  },
  {
    name: "Prachi",
    testament:
      "Unki ayurvedic nuskhe se mere skin ki problems kafi had tak thik ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Indore, Madhya Pradesh",
  },
  {
    name: "Amit",
    testament:
      "Sudama Aushdhalya ke upchar se mere face ke pimples gayab ho gaye hai. Mai unko recommend karunga!",
    location: "Thane, Maharashtra",
  },
  {
    name: "Nidhi",
    testament:
      "Unke herbal dawaiyon se mere skin ke daag-dhabbe dur ho gaye hai. Unka treatment bahut effective hai!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Rohit",
    testament:
      "Sudama Aushdhalya ki ayurvedic dawaiyon se mere hair fall ki samasya dur ho gayi hai. Bahut accha hai unka treatment!",
    location: "Jaipur, Rajasthan",
  },
  {
    name: "Kriti",
    testament:
      "Mere skin ki khujli aur sujan ko Sudama Aushdhalya ke upchar ne thik kiya. Mai unka bahut abhari hu!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Rahul",
    testament:
      "Unke sujhaav se meri skin ki problem dur ho gayi hai. Sudama Aushdhalya ka treatment bahut asardar hai!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Anjali",
    testament:
      "Mujhe psoriasis ki problem thi, lekin Sudama Aushdhalya ke upchar se ab meri skin normal hai. Unka bahut bahut shukriya!",
    location: "Kolkata, West Bengal",
  },
  {
    name: "Alok",
    testament:
      "Unki ayurvedic dawaiyon se mere face ke daag-dhabbe gayab ho gaye. Ab meri skin chamak rahi hai!",
    location: "Visakhapatnam, Andhra Pradesh",
  },
  {
    name: "Tanvi",
    testament:
      "Sudama Aushdhalya ke herbal upchar se mere skin ki glow badhi hai. Unka treatment bahut accha hai!",
    location: "Chennai, Tamil Nadu",
  },
  {
    name: "Arjun",
    testament:
      "Mere hair fall ki problem ko thik karne ke liye Sudama Aushdhalya ne mujhe ek acha solution diya. Unka treatment mujhe pasand aaya!",
    location: "Mumbai, Maharashtra",
  },
  {
    name: "Kavya",
    testament:
      "Unki ayurvedic skin care tips se mere skin ki dryness aur roughness dur ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Delhi",
  },
  {
    name: "Shubham",
    testament:
      "Sudama Aushdhalya ke upchar se mere chehre ki jhuriya kam ho gayi hai. Unka treatment bahut effective hai!",
    location: "Hyderabad, Telangana",
  },
  {
    name: "Nisha",
    testament:
      "Mere dark circles ko thik karne ke liye Sudama Aushdhalya ke tips ne kaam kiya. Mai unko recommend karungi!",
    location: "Ahmedabad, Gujarat",
  },
  {
    name: "Ravi",
    testament:
      "Unki ayurvedic dawaiyon se mere skin ki allergy kafi had tak thik ho gayi hai. Unka bahut bahut shukriya!",
    location: "Pune, Maharashtra",
  },
  {
    name: "Aarti",
    testament:
      "Sudama Aushdhalya ki vajah se meri skin ki jalan aur khujli gayab ho gayi hai. Unka treatment bahut accha hai!",
    location: "Lucknow, Uttar Pradesh",
  },
  {
    name: "Vikas",
    testament:
      "Mere chehre par jo muhase the, unka koi asar nahi dikhta tha. Lekin Sudama Aushdhalya ke upchar se ab meri skin saaf hai!",
    location: "Chandigarh",
  },
  {
    name: "Juhi",
    testament:
      "Unki ayurvedic dawaiyon se mere baalon ki samasya dur ho gayi hai. Mai unko dhanyavaad karti hu!",
    location: "Bhopal, Madhya Pradesh",
  },
  {
    name: "Raj",
    testament:
      "Sudama Aushdhalya ke tips se mere face ke daag-dhabbe kam ho gaye. Unka treatment mujhe pasand aaya!",
    location: "Gurugram, Haryana",
  },
  {
    name: "Prachi",
    testament:
      "Unki ayurvedic nuskhe se mere skin ki problems kafi had tak thik ho gayi hai. Mai unka shukriya ada karti hu!",
    location: "Indore, Madhya Pradesh",
  },
  {
    name: "Amit",
    testament:
      "Sudama Aushdhalya ke upchar se mere face ke pimples gayab ho gaye hai. Mai unko recommend karunga!",
    location: "Thane, Maharashtra",
  },
];
